import styled, { css } from 'styled-components';

import { pickColor } from 'themes/helpers/pickColor';

import { CheckboxMotives, pickMotive } from './checkboxMotives';

export type StyledCheckboxProps = {
  disabled?: boolean;
  motive?: CheckboxMotives;
};

const Container = styled.div<StyledCheckboxProps>`
  display: flex;
  align-items: center;

  height: 3.7rem;
  padding: 1rem 1.3rem;

  background-color: ${pickColor('white')};

  ${({ motive }) => motive && pickMotive(motive)};

  ${({ disabled }) =>
    disabled
      ? css`
          background-color: ${pickColor('borderColorDark')};
          border-color: ${pickColor('borderColorDark')};
        `
      : null}
`;

const Label = styled.label`
  margin-top: 0.2rem;
  margin-left: 0.8rem;

  font-size: 1.2rem;
  font-weight: 600;
`;

const Checkbox = styled.input.attrs({ type: 'checkbox' })<StyledCheckboxProps>`
  display: inline-flex;
  -webkit-appearance: none;

  width: 1.6rem;
  height: 1.6rem;

  border: 0.1rem solid ${pickColor('colmarBlue')};
  border-radius: ${({ theme }) => theme.borderRadius.base};
  background: ${({ checked }) => pickColor(checked ? 'colmarBlue' : 'blueTransparent')};

  cursor: pointer;

  &:after {
    display: block;

    width: 100%;
    margin: 0.2rem;

    content: '';

    transition: 200ms ease-in-out;

    background-color: transparent;
  }

  ${({ disabled }) =>
    disabled
      ? css`
          cursor: not-allowed;
          filter: grayscale(80%);
        `
      : null}
`;

export { Container, Label, Checkbox };
